import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable()
export class MenuService {
  menuItems = new BehaviorSubject<any>([]);

  constructor() {
    // this.menuItems = [];
  }

  addMenu(
    items: {
      text: string;
      heading?: boolean;
      link?: string; // internal route links
      elink?: string; // used only for external links
      target?: string; // anchor target="_blank|_self|_parent|_top|framename"
      icon?: string;
      alert?: string;
      submenu?: any[];
    }[],
  ) {
    const zwischenArray = [];
    items.forEach((item) => {
      zwischenArray.push(item);
    });
    this.menuItems.next(zwischenArray);
  }

  getMenu() {
    console.log(this.menuItems.getValue());
    return this.menuItems.getValue();
  }
}
